export const dlRegistrationErrorEvent = (firstName, lastName, email, errorMessage) => {
    window.dataLayer.push({
        event: 'registration_error',
        reg_data: {
            firstName,
            lastName,
            email,
            errorMessage
        }
    });
};
